export const getPrecipitationType = (main, description) => {
  if (typeof main !== "string") return "none";

  const mainLower = main.toLowerCase();
  const descLower = typeof description === "string" ? description.toLowerCase() : "";

  if (mainLower.includes("thunderstorm")) {
    return descLower.includes("heavy") ? "severe thunderstorm" : "thunderstorm";
  }

  if (mainLower.includes("drizzle")) {
    return "drizzle";
  }

  if (mainLower.includes("rain")) {
    if (descLower.includes("light")) return "light rain";
    if (descLower.includes("heavy")) return "heavy rain";
    if (descLower.includes("shower")) return "showers";
    if (descLower.includes("freezing")) return "freezing rain";
    return "rain";
  }

  if (mainLower.includes("snow")) {
    if (descLower.includes("light")) return "light snow";
    if (descLower.includes("heavy")) return "heavy snow";
    if (descLower.includes("shower")) return "snow showers";
    if (descLower.includes("sleet")) return "sleet";
    return "snow";
  }

  if (mainLower.includes("mist") || mainLower.includes("fog")) {
    return "fog";
  }

  if (mainLower.includes("clear")) {
    return "clear";
  }

  if (mainLower.includes("cloud")) {
    if (descLower.includes("few") || descLower.includes("scattered"))
      return "partly cloudy";
    if (descLower.includes("broken") || descLower.includes("overcast"))
      return "mostly cloudy";
    return "cloudy";
  }

  return "none";
};

export const getWeeklyPrecipitationType = (forecastDays) => {
  if (!forecastDays?.length) return "none";

  const types = forecastDays
    .map((day) => {
      const main = day?.weather?.[0]?.main;
      return typeof main === "string" ? main.toLowerCase() : "";
    })
    .filter(Boolean);

  const hasSnow = types.some((type) => type.includes("snow"));
  const hasRain = types.some(
    (type) => type.includes("rain") || type.includes("drizzle")
  );
  const hasThunder = types.some((type) => type.includes("thunderstorm"));

  if (hasSnow && hasRain) return "wintry mix";
  if (hasThunder) return "thunderstorm";
  if (hasSnow) return "snow";
  if (hasRain) return "rain";

  return "none";
};
